export default __webpack_public_path__ + "static/media/assign-owner.0e6c41ec.svg";